
import StoryblokComponent from '~/components/Storyblok/Component'
export default {
  comments: { StoryblokComponent },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok.background

      return styles
    },
    noteStyles() {
      const styles = {}

      styles.background = this.blok.noteBackgroundColor

      return styles
    },
  },
}
